// src/services/cashService.js
import axiosInstance from './axiosConfig';

const cashhService = {
  /**
   * Get all cash movements
   * @param {number} limit - Maximum number of records to fetch
   */
  getAll: async (limit = 10000) => {
    try {
      const response = await axiosInstance.get('/sales/cashh', {
        params: { limit }
      });

      const res = response.data;

      // Normalize API response
      if (Array.isArray(res)) return res;
      if (Array.isArray(res.data)) return res.data;
      if (res.success && Array.isArray(res.data)) return res.data;

      return [];
    } catch (error) {
      console.error('Error fetching cash movements:', error);
      throw error;
    }
  },

  /**
   * Get cash movements filtered by type
   * @param {string} type - Type of movement (CASH, COLLECTION, CHEQUE)
   * @param {number} limit - Maximum number of records
   */
  getByType: async (type, limit = 10000) => {
    try {
      const response = await axiosInstance.get('/sales/cashh', {
        params: { 
          limit,
          type 
        }
      });

      const res = response.data;

      if (Array.isArray(res)) return res;
      if (Array.isArray(res.data)) return res.data;
      if (res.success && Array.isArray(res.data)) return res.data;

      return [];
    } catch (error) {
      console.error('Error fetching cash movements by type:', error);
      throw error;
    }
  },

  /**
   * Get cash movements by date range
   * @param {string} startDate - Start date (YYYY-MM-DD)
   * @param {string} endDate - End date (YYYY-MM-DD)
   * @param {number} limit - Maximum number of records
   */
  getByDateRange: async (startDate, endDate, limit = 10000) => {
    try {
      const response = await axiosInstance.get('/sales/cashh', {
        params: { 
          limit,
          startDate,
          endDate
        }
      });

      const res = response.data;

      if (Array.isArray(res)) return res;
      if (Array.isArray(res.data)) return res.data;
      if (res.success && Array.isArray(res.data)) return res.data;

      return [];
    } catch (error) {
      console.error('Error fetching cash movements by date:', error);
      throw error;
    }
  },

  /**
   * Get sales persons (for dropdown)
   * TODO: Update this endpoint when available
   */
  getSalesPersons: async () => {
    try {
      // Placeholder - update with actual endpoint when available
      const response = await axiosInstance.get('/users/salespersons');
      return response.data;
    } catch (error) {
      console.error('Error fetching sales persons:', error);
      return [];
    }
  },

  /**
   * Get inventories (for dropdown)
   * TODO: Update this endpoint when available
   */
  getInventories: async () => {
    try {
      // Placeholder - update with actual endpoint when available
      const response = await axiosInstance.get('/inventories');
      return response.data;
    } catch (error) {
      console.error('Error fetching inventories:', error);
      return [];
    }
  }
};

export default cashhService;